import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const MealIngredientCategoryGroceryTable = props => {
  const { data } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Sort</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data && data.map(grocery => (
                  <TableRow className={'table-row'} key={grocery.id} hover>
                    <TableCell>{grocery.id}</TableCell>
                    <TableCell>{grocery.title}</TableCell>
                    <TableCell>{grocery.sort}</TableCell>
                    <TableCell>{grocery.active ? 'TRUE' : 'FALSE'}</TableCell>
                    <TableCell>{formatDateTime(grocery.createdAt)}</TableCell>
                    <TableCell>
                      <EditBtn history={props.history} path={`/meal-ingredient/category-grocery/edit/${grocery.id}`} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  )
}

export default MealIngredientCategoryGroceryTable